import React, { useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";
import Avatar from "@material-ui/core/Avatar";
import { useSelector } from "react-redux";
import { Tooltip } from "@material-ui/core";

/** 404 / yüklenemeyen fotoğraflar — remount'ta tekrar istek atılmasın */
const missingAvatarKeys = new Set();

function avatarCacheKey(typeGroup, id) {
  return `${typeGroup ? "g" : "u"}:${id}`;
}

const AvatarView = ({
  displayName,
  alt,
  src,
  className,
  onClick,
  id,
  typeGroup = false,
  showCircle = false,
  showToolTip = false,
}) => {
  let result = "";
  let tokens = [];
  const refreshAvatar = useSelector(
    (state) => state.messagingManagement.refreshAvatar
  );
  const userAvatarVersion = useSelector((state) =>
    id && !typeGroup
      ? state.messagingManagement.avatarVersions?.[id] || 0
      : 0
  );
  const version = typeGroup ? refreshAvatar : userAvatarVersion;
  const [number, setNumber] = useState(version);
  const cacheKey = id ? avatarCacheKey(typeGroup, id) : null;
  const [imgFailed, setImgFailed] = useState(() =>
    cacheKey ? missingAvatarKeys.has(cacheKey) : false
  );
  const prevVersion = useRef(version);

  if (displayName && typeof displayName.split === "function") {
    tokens = displayName.split(/\s/);
  }
  for (let i = 0; i < tokens.length; i++) {
    if (i < 2) result += tokens[i].substring(0, 1).toUpperCase();
  }

  let resolvedSrc = src;
  const knownMissing =
    imgFailed || (cacheKey && missingAvatarKeys.has(cacheKey));
  const canLoadRemote = id && id.length > 8 && !knownMissing;

  if (canLoadRemote && !typeGroup) {
    resolvedSrc = [
      window.config.managementServiceUrl,
      "user/photo?id=",
      id,
      "&t=",
      number,
    ].join("");
  } else if (canLoadRemote && typeGroup) {
    resolvedSrc = [
      window.config.managementServiceUrl,
      "messagingGroup/",
      id,
      "/avatar?t=",
      number,
    ].join("");
  } else if (id && id.length > 8 && knownMissing) {
    resolvedSrc = undefined;
  }

  useEffect(() => {
    setImgFailed(cacheKey ? missingAvatarKeys.has(cacheKey) : false);
  }, [cacheKey]);

  useEffect(() => {
    if (prevVersion.current === version) return;
    prevVersion.current = version;
    setNumber(version);
    if (cacheKey) {
      missingAvatarKeys.delete(cacheKey);
      setImgFailed(false);
    }
  }, [version, cacheKey]);

  const handleImgError = () => {
    if (cacheKey) missingAvatarKeys.add(cacheKey);
    setImgFailed(true);
  };

  const avatarProps = {
    className,
    alt,
    src: resolvedSrc,
    onClick,
    imgProps: { onError: handleImgError },
  };

  return (
    <Tooltip title={showToolTip ? displayName : ""}>
      {showCircle ? (
        <Avatar style={{ border: "3px solid purple" }} {...avatarProps}>
          {result}
        </Avatar>
      ) : (
        <Avatar {...avatarProps}>{result}</Avatar>
      )}
    </Tooltip>
  );
};

AvatarView.propTypes = {
  displayName: PropTypes.string,
};

export default AvatarView;
